import isEmpty from 'lodash/isEmpty';

export default function joinExisty(values, separator) {
  return values.filter((value) => !isEmpty(value)).join(separator);
}
